export default "__VITE_ASSET__DaUflgER__"